import { defineComponent, ref, shallowRef, watch, onUnmounted, openBlock, createBlock, unref, withCtx, createElementVNode, createElementBlock, Fragment, renderList, toDisplayString, createVNode, createTextVNode } from 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
import '@ssml-editor/core';
import { Button, EditorUtils } from '@ssml-editor/vue';
/* empty css                                                                                                                                                   */
/* empty css                                                     */
import '@ssml-editor/modules';
import Popover from '../../../component/popover/popover.js';
import { Alphabet } from '../../module/phoneme/alphabet.enum.js';
import { PHONEME_TYPE } from '../../module/phoneme/constant.js';
import '../../module/say-as/say-as-interpretation.enum.js';
import '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import { Warning } from '@ssml-editor/base';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                      */
import { dictionary } from 'cmu-pronouncing-dictionary';
import { EnglishMenuService } from './english-menu-service.js';
/* empty css                 */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                        */
import '../say-as/constant.js';
/* empty css                        */
import '@element-plus/icons-vue';
/* empty css                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                       */
/* empty css                         */
/* empty css                     */
/* empty css                                  */
/* empty css                             */
/* empty css                         */
import '../voice/voice-menu.vue.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "english-menu",
  props: {
    editor: {}
  },
  setup(__props) {
    const props = __props;
    const popoverVisible = ref(false);
    const englishList = ref([]);
    const englishMenuService = shallowRef();
    function show() {
      popoverVisible.value = true;
    }
    function hide() {
      popoverVisible.value = false;
    }
    async function menuClickHandler() {
      const editor = props.editor;
      if (editor) {
        englishMenuService.value ??= new EnglishMenuService(editor);
        const node = EditorUtils.findSelectedNodeByType(editor, PHONEME_TYPE);
        if (node) {
          EditorUtils.selectByNode(editor, node);
        } else {
          EditorUtils.trimSelection(editor);
        }
        if (!englishMenuService.value.isDisabled()) {
          const text = englishMenuService.value.getText();
          if (text) {
            const phoneme = dictionary[text];
            if (phoneme) {
              englishList.value = [{
                label: phoneme,
                value: phoneme
              }];
            } else {
              englishList.value = [];
            }
            if (englishList.value.length > 0) {
              show();
            } else {
              throw new Warning("未找到音标");
            }
          }
        }
      }
    }
    function listItemClickHandler(item) {
      englishMenuService.value?.setNode(item.value, item.label);
      hide();
    }
    function ssmlMarkClickHandler(_eventName, _editor, element) {
      if (element.type === PHONEME_TYPE) {
        if (element.alphabet === Alphabet.CMU) {
          englishMenuService.value = void 0;
          menuClickHandler();
        }
      }
    }
    watch(() => props.editor, (newValue, oldValue) => {
      oldValue?.off("ssml-mark-click", ssmlMarkClickHandler);
      newValue?.on("ssml-mark-click", ssmlMarkClickHandler);
    }, {
      immediate: true
    });
    onUnmounted(() => {
      props.editor?.off("ssml-mark-click", ssmlMarkClickHandler);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Popover), {
        modelValue: popoverVisible.value,
        "onUpdate:modelValue": ($event) => popoverVisible.value = $event,
        "show-footer": false
      }, {
        reference: withCtx(() => [
          createVNode(unref(Button), {
            "icon-class": "iconfont-ssml-editor icon-ssml-editor-yinbiao",
            onClick: menuClickHandler
          }, {
            default: withCtx(() => [
              createTextVNode("音标")
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createElementVNode("ul", { class: "se-english" }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(englishList.value, (item, index) => {
              return openBlock(), createElementBlock("li", {
                key: index,
                onClick: ($event) => listItemClickHandler(item)
              }, toDisplayString(item.label), 9, ["onClick"]);
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onUpdate:modelValue"]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=english-menu.vue2.js.map
